import { useAuth } from '@tsuyosa/auth';
import { Link } from 'react-router-dom';

export function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="mx-auto max-w-5xl px-4 py-10">
      {/* Greeting */}
      <div className="mb-8">
        <p className="text-sm text-white/40">Selamat datang kembali,</p>
        <h1 className="mt-1 text-2xl font-bold text-white">
          {user?.display_name ?? user?.username ?? '—'}
        </h1>
      </div>

      {/* Quick links */}
      <div className="grid gap-4 sm:grid-cols-2">
        <Link
          to="/members"
          className="group rounded-xl border border-white/5 bg-[#130d1a] p-5 transition-colors hover:border-[#f472b6]/30"
        >
          <h2 className="mb-1 font-semibold text-white group-hover:text-gradient-tsuyosa">
            Member
          </h2>
          <p className="text-sm text-white/40">Kenali semua member Tsuyosa.</p>
        </Link>

        <Link
          to="/discography"
          className="group rounded-xl border border-white/5 bg-[#130d1a] p-5 transition-colors hover:border-[#f472b6]/30"
        >
          <h2 className="mb-1 font-semibold text-white group-hover:text-gradient-tsuyosa">
            Discography
          </h2>
          <p className="text-sm text-white/40">Temukan semua karya dan rilis Tsuyosa.</p>
        </Link>

        <Link
          to="/profile"
          className="group rounded-xl border border-white/5 bg-[#130d1a] p-5 transition-colors hover:border-[#f472b6]/30"
        >
          <h2 className="mb-1 font-semibold text-white group-hover:text-gradient-tsuyosa">
            Profil Saya
          </h2>
          <p className="text-sm text-white/40">Lihat dan edit informasi akunmu.</p>
        </Link>

        <a
          href="https://tsuyosa.id"
          target="_blank"
          rel="noreferrer"
          className="group rounded-xl border border-white/5 bg-[#130d1a] p-5 transition-colors hover:border-[#f472b6]/30"
        >
          <h2 className="mb-1 font-semibold text-white group-hover:text-gradient-tsuyosa">
            Website Tsuyosa
          </h2>
          <p className="text-sm text-white/40">Kunjungi website resmi Tsuyosa.</p>
        </a>
      </div>
    </div>
  );
}
